<template src="./index.html" />
<script>
import {
  mapState, mapActions, mapGetters,
} from 'vuex';
import cognitoGroups from '@/constants/cognitoGroups';
export default {
  name: 'UserGroupsModal',
  data: () => ({
    dialog: false,
    selectedGroup: '',
    currentGroup: '',
    groups: [
      {
        title: 'Free',
        value: 'free',
      },
      {
        title: 'Collaborator',
        value: cognitoGroups.COLLABORATOR,
      },
      {
        title: 'Pro',
        value: cognitoGroups.PRO,
      },
    ],
  }),
  computed: {
    ...mapState(['showUserGroupsgModal', 'userGroups']),
    ...mapGetters('SiteConfiguration', ['useReviseCollaboratorsToFree']),
    filteredGroups() {
      if (!this.useReviseCollaboratorsToFree) {
        return this.groups;
      }
      return this.groups.filter(({ title }) => title !== 'Collaborator');
    },
  },
  watch: {
    showUserGroupsgModal() {
      if (!this.dialog) {
        this.dialog = true;
        this.getUserGroups();
      } else {
        this.dialog = false;
      }
    },
    userGroups(val) {
      const groups = val && val.map(i => i.name);
      if (groups.includes(cognitoGroups.PRO)) {
        this.selectedGroup = cognitoGroups.PRO;
        this.currentGroup = cognitoGroups.PRO;
      } else if (groups.includes(cognitoGroups.COLLABORATOR)) {
        this.selectedGroup = cognitoGroups.COLLABORATOR;
        this.currentGroup = cognitoGroups.COLLABORATOR;
      } else {
        this.selectedGroup = 'free';
        this.currentGroup = 'free';
      }
    },
  },
  methods: {
    ...mapActions(['changeUserGroups', 'getUserGroups']),
    updateGroups() {
      let groupsToAdd;
      let groupsToRemove;
      switch (this.selectedGroup) {
      case cognitoGroups.PRO:
        groupsToAdd = [cognitoGroups.PRO, cognitoGroups.COLLABORATOR];
        groupsToRemove = [];
        break;
      case cognitoGroups.COLLABORATOR:
        groupsToAdd = [cognitoGroups.COLLABORATOR];
        groupsToRemove = [cognitoGroups.PRO];
        break;
      default:
        groupsToAdd = [];
        groupsToRemove = [cognitoGroups.PRO, cognitoGroups.COLLABORATOR];
      }
      this.changeUserGroups({
        groupsToAdd,
        groupsToRemove,
        removeFromList: this.$route.params.mode !== 'all' && this.selectedGroup === 'free',
      });
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
